import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Heander from "../HeaderPortalVendedor";
import Swal from "sweetalert2";
// import { MenuAdmin } from "../../componentes/menu-admin-fornada.js";
import { Container, HomeFornada } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBAlert,
} from "mdbreact";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Carregando from "../../Componentes/Carregando.js";
import { URLBunge } from "../../Componentes/Config";
// import PtBr from "date-fns/locale/pt-BR";

// import { formatRFC3339WithOptions } from "date-fns/fp";

var dataTable = {
  columns: [
    {
      label: "Id Cupom",
      field: "id",
      sort: "asc",
      width: 100,
    },
    {
      label: "Cupom",
      field: "cupom",
      sort: "asc",
      width: 100,
    },
    {
      label: "Inicio",
      field: "inicio",
      sort: "asc",
      width: 100,
    },
    {
      label: "Termino",
      field: "termino",
      sort: "asc",
      width: 100,
    },
    {
      label: "Desconto % no produto",
      field: "produtoDescPerc",
      sort: "asc",
      width: 100,
    },
    {
      label: "Desconto % no frete",
      field: "freteDescPerc",
      sort: "asc",
      width: 100,
    },
    /*  {
      label: "Desconto R$",
      field: "produtoDescFixo",
      sort: "asc",
      width: 100,
    }, */
    {
      label: "Qtd de voucher",
      field: "disponiveis",
      sort: "asc",
      width: 100,
    },
    {
      label: "Qtd utilizada",
      field: "utilizados",
      sort: "asc",
      width: 100,
    },
    {
      label: "Descrição",
      field: "descricao",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Consultar",
      field: "editar",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

let arquivo = [];

let TOKEN =
  "eyJhbGciOiJSUzI1NiIsImtpZCI6IkY3NEM3NEEyRkRDOTJBMEVEMUEwRjZEMUUyMDVBQjlGOTcxNDM4OTUiLCJ0eXAiOiJKV1QiLCJ4NXQiOiI5MHgwb3YzSktnN1JvUGJSNGdXcm41Y1VPSlUifQ.eyJuYmYiOjE2MzE3MDkzNjUsImV4cCI6MTk0NzA2OTM2NSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDk0IiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3Q6ODA5NC9yZXNvdXJjZXMiLCJhcHBidW5nZUdXIiwiY2F0YWxvZ29HVyIsIm9tbmlvbkdXIl0sImNsaWVudF9pZCI6IkFwcEJ1bmdlQ2xpZW50Iiwic3ViIjoiNWNiYTljMjAtMDBjMC00YjU1LTRkZDMtMDhkN2Q2NzFmNmQ1IiwiYXV0aF90aW1lIjoxNjMxNzA5MzYzLCJpZHAiOiJsb2NhbCIsIkZ1bGxOYW1lIjoiICIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWVpZGVudGlmaWVyIjoiNWNiYTljMjAtMDBjMC00YjU1LTRkZDMtMDhkN2Q2NzFmNmQ1IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6IjAxODI3Nzc2MTg4Iiwic2NvcGUiOlsiYXBpYXBwYnVuZ2UiLCJhcGljYXRhbG9nbyIsImFwaW9tbmlvbiIsIm9mZmxpbmVfYWNjZXNzIl0sImFtciI6WyJwd2QiXX0.iSSbiUlA7X2xD3wDHGV94ogdAFtGC_pj5sPNu3ue1wTpHLfvHVlXdIdR38KO1cXU-ef0mhEP9R1ZtBeo-qnWwuut5-kWZXxh-h6DRkJphreu-CF6Gi3KsQXwTOj6NzNES9xFD_3Rv6pWebQ7FP5ZpyfnouUPD3brF7UBPRbEis2bPiUIGoiP1MnMXnNdLEh8NVfC6qks_yo-CWLkDgD2KsPw32fcP5OYb3PIqE-CP6bZA1uX2vd4hum6NrM5NDUzwdT6uxe9X5jfTf4hJv2dtBfUbLZXo1RFjQ1qWQFAMRpn2jCTDEZiY-O9ymj7OaOozJgUzBNRwz3taq_BQhcaFA";
let EMAIL_USUARIO = "AdminVendedor";
class Home extends Component {
  state = {
    att: false,
    departamento: "",
    dataIni: new Date(),
    dataFim: new Date(),
    cupomTable: {},
    cupom: "",
    disponiveis: 0,
    tipoDesc: 0,
    produtoValorMin: "", //Valor mínimo para produtoDescPerc
    produtoDescPerc: 0,
    produtoDescFixo: 0,
    freteDescPerc: 0,
    freteDescFixo: 0,
    freteValorMin: "", //Valor mínimo para frete
    ativo: true,
    plataforma: "",
    descricao: "",
    //cluster, uf, cargo
    acaoId: null,
    estadosId: [],
    profissoesId: [],
    clustersId: [],

    id: null,
    utilizados: 0,
    ListaUf: [],
    ListaCluster: [],
    Profissao: [],
    Cluster: [],
    Update: 0,
    UpdateCluster: 0,

    editar: "",
    readOnly: false,
    disabled: "",
    tipo: "",
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var retornoAcesso = await fetch(
      `${URLBunge}/api/AdminVendedor/DadosUser/${2329681}/${EMAIL_USUARIO}`,
      requestOptions
    ).then((response) => response.json());
    if (retornoAcesso.sucesso === false) {
      this.setState({ departamento: retornoAcesso.mensagem });
    }
    this.CarregaProfissoes();
    this.CarregaCluster();
    this.carregaCupom({ ProjetoId: 2329681 });
  }

  CarregaProfissoes = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer" + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var retornoProf = await fetch(
      `${URLBunge}/Api/Cliente/ListaProfissao`,
      requestOptions
    ).then((response) => response.json());
    if (retornoProf.sucesso)
      this.setState({ Profissao: retornoProf.profissoes });
  };

  CarregaCluster = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var cluster = await fetch(
      `${URLBunge}/api/Cliente/BuscarClusters`,
      requestOptions
    ).then((response) => response.json());
    console.log("*******", cluster);
    if (cluster.sucesso) this.setState({ Cluster: cluster.listaClusters });
  };

  ListaUf = (cod) => {
    var ListaUf = this.state.estadosId;
    if (ListaUf.indexOf(cod) > -1) {
      ListaUf.splice(ListaUf.indexOf(cod), 1);
    } else {
      ListaUf.push(cod);
    }
    this.setState({ ListaUf });
    console.log("TESTE UF", this.state.estadosId);
  };

  ListaProfissao = (e) => {
    var ListaProfissao = this.state.profissoesId;
    if (e.checked) {
      ListaProfissao.push(parseInt(e.value));
    } else {
      var index = ListaProfissao.indexOf(parseInt(e.value));
      if (index > -1) {
        ListaProfissao.splice(index, 1);
      }
    }
    console.log("TESTE ListaProfissao", this.state.profissoesId);
  };

  ListaCluster = (e) => {
    var ListaCluster = this.state.clustersId;
    if (e.checked) {
      ListaCluster.push(parseInt(e.value));
    } else {
      var index = ListaCluster.indexOf(parseInt(e.value));
      if (index > -1) {
        ListaCluster.splice(index, 1);
      }
    }
    console.log("TESTE ListaVisao", this.state.clustersId);
  };

  carregaCupom = async (busca) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(busca),
      redirect: "follow",
    };
    var resCupom = await fetch(
      `${URLBunge}/api/Promocode/Buscar/`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => this.setState({ loading: false }));

    if (resCupom && resCupom.sucesso) {
      let cupomTable = dataTable;

      cupomTable.rows = [];
      resCupom.promocodes.forEach((cupom) => {
        let departamento = this.state.departamento;
        //console.log('TESTE departamento', departamento);
        var dataIni = cupom.validadeInicio.split("T");
        dataIni = dataIni[0].split("-").reverse().join("/");
        var dataFim = cupom.validadeFim.split("T");
        dataFim = dataFim[0].split("-").reverse().join("/");

        let cupomNovo = {
          id: cupom.id,
          tipo: cupom.Tipo,
          status: cupom.ativo ? "ATIVO" : "INATIVO",
          cupom: cupom.codigoCupom,
          inicio: dataIni,
          termino: dataFim,
          produtoDescPerc: cupom.produtoDescPerc.toFixed(0) + "%",
          produtoDescFixo: cupom.produtoDescFixo.toFixed(2),
          produtoValorMin: cupom.produtoValorMin.toFixed(2),
          freteDescFixo: cupom.freteDescFixo.toFixed(2),
          freteDescPerc: cupom.freteDescPerc.toFixed(0) + "%",
          freteValorMin: cupom.freteValorMin.toFixed(2),
          disponiveis: cupom.disponiveis,
          utilizados: cupom.utilizados,
          descricao: cupom.descricao,
          plataforma: "",

          acaoId: cupom.acaoId,
          estadosId: cupom.estadosId,
          profissoesId: cupom.profissoesId,
          clustersId: cupom.clustersId,

          editar:
            departamento === "11" ? (
              <MDBBtn
                color="blue"
                size="sm"
                onClick={() => this.toggleedit(3, cupom.id)}
              >
                {" "}
                Consultar{" "}
              </MDBBtn>
            ) : (
              " - "
            ),
        };

        cupomTable.rows.push(cupomNovo);
      });

      this.setState({ cupomTable });
    }
    this.setState({ loading: false });
  };

  EditListaCupom = async (id) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    this.setState({ editar: "notedit" });
    this.setState({ readOnly: true });
    this.setState({ disabled: "disabled" });

    var Cupom = await fetch(
      `${URLBunge}/api/Promocode/PromoCodeListaVisao/${id}`,
      requestOptions
    ).then((response)=> response.json())
    this.setState({ id: id });
    console.log("TESTE Cupom full", Cupom);

    const cupom = Cupom.listaCupom[0];
    this.setState({ dataIni: cupom.validadeInicio });
    this.setState({ dataFim: cupom.validadeFim });
    this.setState({ ativo: cupom.ativo });
    this.setState({ descricao: cupom.descricao });
    this.setState({ estadosId: cupom.estados });
    this.setState({ profissoesId: cupom.profissoesId });
    this.setState({ acaoId: cupom.acao });
    this.setState({ clustersId: cupom.clustersId });

    //console.log('TESTE Cupom tipo', cupom)
  };

  toggleedit = (nr, id) => {
    this.EditListaCupom(id);

    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  AlteraStatus = async (ativo) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dados),
      redirect: "follow",
    };
    let status = this.state.ativo;
    if (status === "true") {
      status = 1;
    } else {
      status = 0;
    }

    const dados = {
      status: status,
      id: this.state.id,
    };
    var response = await fetch(
      `${URLBunge}/api/Promocode/PromocodeAlteraStatus/`,
      requestOptions
    ).then((response) => response.json());
    console.log("TESTE altera:", response);
    if (response.data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Parabéns!",
        text: "Cupom alterado com sucesso!",
      }).then(function () {
        window.location = window.location;
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: response.data.mensagem,
      });
    }
  };

  toggle = (nr, cupom) => {
    if (cupom != null && cupom !== undefined) {
      this.setState({ editar: "notedit" });
      this.setState({ readOnly: true });
      this.setState({ disabled: "disabled" });

      var tipo = "";
      if (cupom.produtoDescFixo > 0) {
        tipo = 2;
      } else {
        tipo = 1;
      }
      this.setState({
        id: cupom.id,
        tipo: cupom.Tipo,
        cupom: cupom.codigoCupom,
        disponiveis: cupom.disponiveis,
        utilizados: cupom.utilizados,
        tipoDesc: tipo,
        produtoValorMin: cupom.produtoValorMin, //Valor mínimo para produtoDescPerc
        produtoDescPerc: cupom.produtoDescPerc,
        freteDescPerc: cupom.freteDescPerc,
        freteValorMin: cupom.freteValorMin,
        ativo: cupom.ativo,
        descricao: cupom.descricao,
        plataforma: cupom.plataforma,
        dataIni: new Date(cupom.validadeInicio),
        dataFim: new Date(cupom.validadeFim),

        acaoId: cupom.acaoId,
        estadosId: cupom.estadosId,
        profissoesId: cupom.profissoesId,
        clustersId: cupom.clustersId,
      });
    } else {
      this.setState({
        id: "",
        cupom: "",
        disponiveis: 0,
        tipoDesc: 0,
        produtoValorMin: 0, //Valor mínimo para produtoDescPerc
        produtoDescPerc: 0,
        produtoDescFixo: 0,
        freteDescPerc: 0,
        freteDescFixo: 0,
        freteValorMin: 0,
        ativo: true,
        descricao: "",
        plataforma: "",
        dataIni: new Date(),
        dataFim: new Date(),

        acaoId: null,
        estadosId: [],
        profissoesId: [],
        clustersId: [],
      });
      this.setState({ editar: "" });
      this.setState({ readOnly: false });
      this.setState({ disabled: "" });
    }
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  salvarCupom = async (tipo) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dadosCupom),
      redirect: "follow",
    };
    var rejeitado = false;

    if (this.state.cupom === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor informe o cupom.",
      });
      rejeitado = true;
      return;
    } else if (this.state.disponiveis === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor informe a quantidade de vouchers disponíveis.",
      });
      rejeitado = true;
      return;
    } else if (this.state.tipoDesc === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor selecione o tipo de produtoDescPerc.",
      });
      rejeitado = true;
      return;
    } else if (
      this.state.plataforma === "" &&
      this.state.plataforma === undefined
    ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor informa a plataforma!",
      });
      rejeitado = true;
      return;
    } else if (this.state.descricao === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor informe a descrição do cupom!",
      });
      rejeitado = true;
      return;
    }

    if (this.state.produtoValorMin === "") {
      this.setState({ produtoValorMin: 0 });
    }

    if (!rejeitado) {
      var dataIni = this.state.dataIni.toLocaleString("sv-SE");
      dataIni = dataIni.replace(" ", "T");

      var dataFim = this.state.dataFim.toLocaleString("sv-SE");
      dataFim = dataFim.replace(" ", "T");

      var vMinimo = this.state.produtoValorMin + "";
      if (vMinimo === "") {
        vMinimo = "0";
      }
      vMinimo = vMinimo.replace(",", ".");
      vMinimo = parseFloat(vMinimo);

      var vMinimoFrete = this.state.freteValorMin + "";
      if (vMinimoFrete === "") {
        vMinimoFrete = "0";
      }
      vMinimoFrete = vMinimoFrete.replace(",", ".");
      vMinimoFrete = parseFloat(vMinimoFrete);

      var descFixo = this.state.produtoDescFixo + "";
      if (descFixo === "") {
        descFixo = "0";
      }
      descFixo = descFixo.replace(",", ".");
      descFixo = parseFloat(descFixo);

      if (this.state.produtoDescPerc === "") {
        this.setState({ produtoDescPerc: 0 });
      }

      var id = this.state.id;
      if (!this.state.id) {
        id = 0;
      }

      let acaoId = this.state.acaoId;
      if (acaoId != null) {
        acaoId = parseInt(acaoId);
      } else {
        acaoId = acaoId;
      }

      var dadosCupom = {
        projetoId: 2329681,
        id: id,
        codigoCupom: this.state.cupom,
        disponiveis: parseInt(this.state.disponiveis),
        utilizados: this.state.utilizados,
        validadeInicio: dataIni,
        validadeFim: dataFim,
        produtoValorMin: vMinimo, //Valor mínimo dos produtos em reais para ativar o produtoDescPerc
        produtoDescPerc: parseInt(this.state.produtoDescPerc),
        Tipo: parseInt(this.state.tipoDesc),
        plataforma: 3,
        produtoDescFixo: 0,
        freteValorMin: vMinimoFrete,
        freteDescPerc: parseInt(this.state.freteDescPerc),
        freteDescFixo: 0,
        ativo: this.state.ativo,
        descricao: this.state.descricao,

        //novos campos
        acao: acaoId,
        estados: this.state.estadosId,
        profissoesId: this.state.profissoesId,
        clustersId: this.state.clustersId,
      };

      console.log("TESTE dadosCupom", dadosCupom);
      //return;

      var resSalva = await fetch(
        `${URLBunge}/api/Promocode/Salvar/ `,
        requestOptions
      ).then((response) => response.json());

      if (resSalva && resSalva.sucesso) {
        Swal.fire({
          icon: "success",
          title: "Parabéns!",
          text: "Cupom cadastrado com sucesso!",
        }).then(function () {
          //this.carregaCupom({ ProjetoId: getProjeto() });
          window.location = window.location;
        });
      } else if (resSalva && resSalva.mensagem) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: resSalva.mensagem,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Um erro inesperado ocorreu.",
        });
      }
    }
  };

  LeArquivo = async (e) => {
    var a = e.target.id;
    var nome = e.target.files[0].name.split(".");
    nome = nome[0];
    this.setState({ nomearquivo: nome });

    if (e.target.files[0].name.indexOf("xlsx") != -1) {
      arquivo[a] = e.target.files[0];

      if (!arquivo[a]) {
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        console.log("TESTE ARQUIVO", reader.result);
      };
      reader.readAsDataURL(arquivo[a]);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Arquivo selecionado não é um Excel",
      });
      this.setState({ nomearquivo: "Escolha o Arquivos" });
      return;
    }
  };

  CadastrarArquivo = async (tipo) => {
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ dataCad, defaultOptions }),
      redirect: "follow",
    }.then((response) => response.json());

    if (this.state.tipo === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Informe o tipo de arquivo que vai enviar!",
      });
      return;
    }

    var dataCad = new FormData();

    await dataCad.append(`idProjeto`, 2329681);
    var XlsName = "";
    if (arquivo["XLSFile"]) {
      await dataCad.append(
        `ArquivoExcel`,
        arquivo["XLSFile"],
        arquivo["XLSFile"].name
      );
      XlsName = arquivo["XLSFile"].name;
    }

    var defaultOptions = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache",
      },
    };

    let UploadArquivo = "";

    if (this.state.tipo === "1") {
      UploadArquivo = await fetch(
        `${URLBunge}/api/Promocode/SalvarExcelPromoCode/`,
        requestOptions
      );
    } else {
      UploadArquivo = await fetch(
        `${URLBunge}/api/Promocode/SalvarExcelPromoCodeLoja/`,
        requestOptions
      );
    }

    console.log("TESTE", UploadArquivo);

    if (UploadArquivo.data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Feito!",
        text: UploadArquivo.data.mensagem,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location = "/PromocodeAdmin";
        }
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: UploadArquivo.data.mensagem,
      });
    }

    this.setState({ loading: false });
  };

  render() {
    return (
      <Container>
        {this.state.loading && <Carregando />}
        <Heander />
        <HomeFornada>
          <div className="clear"></div>

          <div className="cadastros">
            <h1>Cadastro de cupom </h1>

            {this.state.departamento === "11" ? (
              <div id="filtros">
                <MDBBtn
                  color="primary"
                  size="sm"
                  onClick={() => {
                    this.setState({ id: null });
                    this.toggle(4);
                  }}
                  style={{ float: "right" }}
                >
                  Cadastrar Cupom
                </MDBBtn>

                <MDBBtn
                  color="success"
                  size="sm"
                  onClick={() => this.toggle(5)}
                  style={{ float: "right" }}
                >
                  Cadastrar por planilha
                </MDBBtn>
              </div>
            ) : (
              <span></span>
            )}

            <div class="tabresp">
              <MDBDataTable
                striped
                bordered
                hover
                searchLabel="Pesquisar"
                paginationLabel={["Anterior", "Próximo"]}
                noRecordsFoundLabel="Nenhum resultado encontrado"
                infoLabel={["Mostrando", "de", "até", "registros"]}
                entriesLabel="Qtd por pagina"
                data={this.state.cupomTable}
              />
            </div>
          </div>

          {/* MODAL CADASTRO */}
          <MDBModal
            // isOpen={true}
            isOpen={this.state.modal4}
            toggle={() => this.toggle(4)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(4)}>
              CADASTRO DE CUPOM
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    {/* Inicio */}
                    <MDBCol md="6" style={{ float: "left", zIndex: "5" }}>
                      <label>Inicio</label>
                      <br />
                      <DatePicker
                        className="form-control"
                        selected={new Date(this.state.dataIni)}
                        onChange={(e) => {
                          var dataIni = new Date(e);
                          this.setState({ dataIni });
                        }}
                        placeholderText="Inicio"
                        showTimeSelect
                        // locale={PtBr}
                        timeFormat="p"
                        dateFormat="dd/MM/yyyy HH:mm"
                        style={{ width: "100%" }}
                      />
                    </MDBCol>

                    {/* Término */}
                    <MDBCol md="6" style={{ float: "left", zIndex: "5" }}>
                      <label>Término</label>
                      <br />
                      <DatePicker
                        className="form-control"
                        selected={new Date(this.state.dataFim)}
                        onChange={(e) => {
                          var dataFim = new Date(e);
                          this.setState({ dataFim });
                        }}
                        placeholderText="Término"
                        // locale={PtBr}
                        showTimeSelect
                        timeFormat="p"
                        dateFormat="dd/MM/yyyy HH:mm"
                        style={{ width: "100%" }}
                      />
                    </MDBCol>

                    {this.state.id === "" ? (
                      <div className="campos100">
                        <MDBRow>
                          {/* CUPOM */}
                          <MDBCol md="6">
                            <MDBInput
                              label="Informe o CUPOM"
                              outline
                              size="lg"
                              value={this.state.cupom}
                              onChange={(e) => {
                                this.setState({ cupom: e.target.value });
                              }}
                            />
                            <small className="sml">Ex: PDVDESCONTO2020</small>
                          </MDBCol>

                          {/* Qtd. de Vouchers */}
                          <MDBCol md="6">
                            <MDBInput
                              label="Qtd. de Vouchers"
                              outline
                              size="lg"
                              value={this.state.disponiveis}
                              onChange={(e) => {
                                this.setState({ disponiveis: e.target.value });
                              }}
                            />
                          </MDBCol>
                        </MDBRow>

                        {/* Tipo de desconto */}
                        <MDBRow>
                          <MDBCol md="6">
                            <label>Tipo de desconto</label>
                            <select
                              className="browser-default custom-select"
                              onChange={(e) =>
                                this.setState({ tipoDesc: e.target.value })
                              }
                            >
                              <option
                                value={0}
                                selected={
                                  this.state.tipoDesc === 0 ? true : false
                                }
                              >
                                Selecione o tipo de Desconto
                              </option>
                              <option
                                value={1}
                                selected={
                                  this.state.tipoDesc === 1 ? true : false
                                }
                              >
                                Porcentagem de desconto nos produtos
                              </option>
                              <option
                                value={2}
                                selected={
                                  this.state.tipoDesc === 2 ? true : false
                                }
                              >
                                Porcentagem de desconto no frete
                              </option>
                              <option
                                value={3}
                                selected={
                                  this.state.tipoDesc === 3 ? true : false
                                }
                              >
                                Porcentagem de desconto no frete e produtos
                              </option>
                              {/*  <option
                                    value={4}
                                    selected={this.state.tipoDesc == 4 ? true : false}
                                  >
                                    Produto bunge
                                  </option> */}
                            </select>
                          </MDBCol>
                        </MDBRow>

                        {/* ITENS TIPO DE DESCONTO */}
                        <MDBRow>
                          {this.state.tipoDesc === 4 ? (
                            <MDBCol md="12">
                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Desconto em % no produto bunge"
                                  outline
                                  size="lg"
                                  value={this.state.produtoDescPerc}
                                  onChange={(e) => {
                                    this.setState({
                                      produtoDescPerc: e.target.value,
                                    });
                                  }}
                                  maxlength="3"
                                />
                              </MDBCol>

                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Valor mínimo dos produtos bunge"
                                  outline
                                  size="lg"
                                  value={this.state.produtoValorMin}
                                  onChange={(e) => {
                                    this.setState({
                                      produtoValorMin: e.target.value,
                                    });
                                  }}
                                />
                                <small style={{ marginTop: "-20px" }}>
                                  Valor minino para produto (R$): Ex: 100
                                </small>
                              </MDBCol>
                            </MDBCol>
                          ) : (
                            <div />
                          )}
                        </MDBRow>

                        <MDBRow>
                          {this.state.tipoDesc == 1 ||
                          this.state.tipoDesc == 3 ? (
                            <MDBCol md="12">
                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Desconto em % no produto"
                                  outline
                                  size="lg"
                                  value={this.state.produtoDescPerc}
                                  onChange={(e) => {
                                    this.setState({
                                      produtoDescPerc: e.target.value,
                                    });
                                  }}
                                  maxlength="3"
                                />
                              </MDBCol>

                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Valor mínimo dos produtos"
                                  outline
                                  size="lg"
                                  value={this.state.produtoValorMin}
                                  onChange={(e) => {
                                    this.setState({
                                      produtoValorMin: e.target.value,
                                    });
                                  }}
                                />
                                <small>
                                  Valor minino para produto (R$): Ex: 100
                                </small>
                              </MDBCol>
                            </MDBCol>
                          ) : (
                            <div />
                          )}
                        </MDBRow>

                        <MDBRow>
                          {this.state.tipoDesc == 2 ||
                          this.state.tipoDesc == 3 ? (
                            <MDBCol md="12">
                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Desconto em % no frete"
                                  outline
                                  size="lg"
                                  value={this.state.freteDescPerc}
                                  onChange={(e) => {
                                    this.setState({
                                      freteDescPerc: e.target.value,
                                    });
                                  }}
                                  maxlength="3"
                                />
                              </MDBCol>

                              <MDBCol md="6" style={{ float: "left" }}>
                                <MDBInput
                                  label="Valor mínimo do frete"
                                  outline
                                  size="lg"
                                  value={this.state.freteValorMin}
                                  onChange={(e) => {
                                    this.setState({
                                      freteValorMin: e.target.value,
                                    });
                                  }}
                                />
                                <small>Valor minino para frete: Ex: 100</small>
                              </MDBCol>
                            </MDBCol>
                          ) : (
                            <div />
                          )}
                        </MDBRow>
                      </div>
                    ) : (
                      <span></span>
                    )}

                    <div className="clear"></div>

                    {/* Ativo */}
                    <MDBRow>
                      <MDBCol md="6">
                        <label>Ativo</label>
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => {
                            if (e.target.value === 1) {
                              this.setState({ ativo: true });
                            } else {
                              this.setState({ ativo: false });
                            }
                          }}
                        >
                          <option value={1} selected={this.state.ativo}>
                            Sim
                          </option>
                          <option value={2} selected={!this.state.ativo}>
                            Não
                          </option>
                        </select>
                      </MDBCol>
                    </MDBRow>

                    {/* Descrição */}
                    <MDBRow>
                      <MDBCol md="12">
                        <label>Descrição</label>
                        <textarea
                          className="form-control"
                          id="Mecanica"
                          rows="3"
                          placeholder="Descrição"
                          value={this.state.descricao}
                          onChange={(e) => {
                            this.setState({
                              descricao: e.target.value,
                            });
                          }}
                        />
                        <small>Ex: 25% de produtoDescPerc</small>
                      </MDBCol>
                    </MDBRow>

                    <div className="clear"></div>

                    <div className={this.state.editar}>
                      {this.state.editar === "notedit" ? (
                        <MDBAlert color="danger">
                          <strong>Atenção:</strong> Estes campos não podem ser
                          editados!
                        </MDBAlert>
                      ) : (
                        <span></span>
                      )}

                      {/* Ação Id*/}
                      <MDBCol md="12" style={{ float: "left" }}>
                        <label>
                          Ação Id{" "}
                          <small>
                            (ID para atribuir lista ou ação, independente de
                            profissão, cargo, UF ou cidade.)
                          </small>
                        </label>
                        <MDBInput
                          label="Ação Id"
                          outline
                          size="lg"
                          value={this.state.acaoId}
                          style={{ width: "200px", marginTop: "-20px" }}
                          onChange={(e) => {
                            this.setState({ acaoId: e.target.value });
                          }}
                          readOnly={this.state.readOnly}
                        />
                      </MDBCol>
                      {/* UF */}
                      <div className="campos100">
                        <label>
                          Para qual UF?{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            os estados)
                          </small>
                        </label>{" "}
                        <br />
                        <div className="campos50">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AC"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AC");
                              }}
                              id={"AC"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AC"}
                            >
                              Acre
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AL"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AL");
                              }}
                              id={"AL"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AL"}
                            >
                              Alagoas
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AP"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AP");
                              }}
                              id={"AP"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AP"}
                            >
                              Amapá
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AM"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AM");
                              }}
                              id={"AM"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AM"}
                            >
                              Amazonas
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "BA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("BA");
                              }}
                              id={"BA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"BA"}
                            >
                              Bahia
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "CE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("CE");
                              }}
                              id={"CE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"CE"}
                            >
                              Ceará
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "DF"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("DF");
                              }}
                              id={"DF"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"DF"}
                            >
                              Distrito Federal
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "ES"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("ES");
                              }}
                              id={"ES"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"ES"}
                            >
                              Espírito Santo
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "GO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("GO");
                              }}
                              id={"GO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"GO"}
                            >
                              Goiás
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MA");
                              }}
                              id={"MA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MA"}
                            >
                              Maranhão
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MT"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MT");
                              }}
                              id={"MT"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MT"}
                            >
                              Mato Grosso
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MS"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MS");
                              }}
                              id={"MS"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MS"}
                            >
                              Mato Grosso do Sul
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MG"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MG");
                              }}
                              id={"MG"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MG"}
                            >
                              Minas Gerais
                            </label>
                          </div>
                        </div>
                        <div className="campos50">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PA");
                              }}
                              id={"PA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PA"}
                            >
                              Pará
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PB"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PB");
                              }}
                              id={"PB"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PB"}
                            >
                              Paraíba
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PR"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PR");
                              }}
                              id={"PR"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PR"}
                            >
                              Paraná
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PE");
                              }}
                              id={"PE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PE"}
                            >
                              Pernambuco
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PI"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PI");
                              }}
                              id={"PI"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PI"}
                            >
                              Piauí
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RJ"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RJ");
                              }}
                              id={"RJ"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RJ"}
                            >
                              Rio de Janeiro
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RN"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RN");
                              }}
                              id={"RN"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RN"}
                            >
                              Rio Grande do Norte
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RO");
                              }}
                              id={"RO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RO"}
                            >
                              Rondônia
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RR"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RR");
                              }}
                              id={"RR"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RR"}
                            >
                              Roraima
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SC"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SC");
                              }}
                              id={"SC"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SC"}
                            >
                              Santa Catarina
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SP"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SP");
                              }}
                              id={"SP"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SP"}
                            >
                              São Paulo
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SE");
                              }}
                              id={"SE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SE"}
                            >
                              Sergipe
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "TO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("TO");
                              }}
                              id={"TO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"TO"}
                            >
                              Tocantins
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Profissão */}
                      <div className="campos100">
                        <label>
                          Escolha a Profissão{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            as profissões){" "}
                          </small>
                        </label>
                        {this.state.Profissao.map((tipo, i) => {
                          return (
                            <div className="linha" key={i}>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  disabled={this.state.disabled}
                                  className="custom-control-input"
                                  value={tipo.cad_cod}
                                  checked={this.state.profissoesId.includes(
                                    tipo.cad_cod
                                  )}
                                  onChange={(e) => {
                                    this.ListaProfissao(e.target);
                                    this.setState({
                                      Update: !this.state.Update,
                                    });
                                  }}
                                  id={tipo.cad_cod}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={tipo.cad_cod}
                                >
                                  {tipo.cad_descricao}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {/* Clusters */}
                      <div className="campos100">
                        <label>
                          Escolha os Clusters{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            os clusters){" "}
                          </small>
                        </label>
                        {this.state.Cluster.map((clus, i) => {
                          return (
                            <div className="linha" key={i}>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  disabled={this.state.disabled}
                                  className="custom-control-input"
                                  value={clus.id}
                                  checked={this.state.clustersId.includes(
                                    clus.id
                                  )}
                                  onChange={(e) => {
                                    this.ListaCluster(e.target);
                                    this.setState({
                                      UpdateCluster: !this.state.UpdateCluster,
                                    });
                                  }}
                                  id={clus.id}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={clus.id}
                                >
                                  {clus.descricao}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => this.salvarCupom("Cadastra")}
              >
                Cadastrar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* MODAL EDIT */}
          <MDBModal
            isOpen={this.state.modal3}
            toggle={() => this.toggle(3)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(3)}>
              CONSULTA DE CUPOM
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBCol md="6" style={{ float: "left", zIndex: "5" }}>
                      <label>Inicio</label>
                      <br />
                      <DatePicker
                        className="form-control"
                        selected={new Date(this.state.dataIni)}
                        onChange={(e) => {
                          var dataIni = new Date(e);
                          this.setState({ dataIni });
                        }}
                        placeholderText="Inicio"
                        // locale={PtBr}
                        showTimeSelect
                        timeFormat="p"
                        dateFormat="dd/MM/yyyy HH:mm"
                        style={{ width: "100%" }}
                        readOnly={this.state.readOnly}
                      />
                    </MDBCol>

                    <MDBCol md="6" style={{ float: "left", zIndex: "5" }}>
                      <label>Término</label>
                      <br />
                      <DatePicker
                        className="form-control"
                        selected={new Date(this.state.dataFim)}
                        onChange={(e) => {
                          var dataFim = new Date(e);
                          this.setState({ dataFim });
                        }}
                        placeholderText="Término"
                        // locale={PtBr}
                        showTimeSelect
                        timeFormat="p"
                        dateFormat="dd/MM/yyyy HH:mm"
                        style={{ width: "100%" }}
                        readOnly={this.state.readOnly}
                      />
                    </MDBCol>

                    {/* Ativo */}
                    <MDBRow>
                      <MDBCol md="6">
                        <label>Ativo</label>
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => {
                            this.setState({ ativo: e.target.value });
                          }}
                        >
                          <option
                            value={true}
                            selected={
                              this.state.ativo === "true" ||
                              this.state.ativo === true
                                ? "selected"
                                : ""
                            }
                          >
                            Sim
                          </option>
                          <option
                            value={false}
                            selected={
                              this.state.ativo === "false" ||
                              this.state.ativo === false
                                ? "selected"
                                : ""
                            }
                          >
                            Não
                          </option>
                        </select>
                      </MDBCol>
                    </MDBRow>

                    {/* Descrição */}
                    <MDBRow>
                      <MDBCol md="12">
                        <label>Descrição</label>
                        <textarea
                          className="form-control"
                          id="Mecanica"
                          rows="3"
                          placeholder="Descrição"
                          value={this.state.descricao}
                          onChange={(e) => {
                            this.setState({
                              descricao: e.target.value,
                            });
                          }}
                          readOnly={this.state.readOnly}
                        />
                        <small>Ex: 25% de produtoDescPerc</small>
                      </MDBCol>
                    </MDBRow>

                    <div className="clear"></div>

                    <div className={this.state.editar}>
                      {this.state.editar === "notedit" ? (
                        <MDBAlert color="danger">
                          <strong>Atenção:</strong> Estes campos não podem ser
                          editados!
                        </MDBAlert>
                      ) : (
                        <span></span>
                      )}

                      {/* Ação Id*/}
                      <MDBCol md="3" style={{ float: "left" }}>
                        <MDBInput
                          label="Ação Id"
                          outline
                          size="lg"
                          value={this.state.acaoId}
                          onChange={(e) => {
                            this.setState({ acaoId: e.target.value });
                          }}
                          readOnly={this.state.readOnly}
                        />
                      </MDBCol>

                      {/* UF */}
                      <div className="campos100">
                        <label>
                          Para qual UF?{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            os estados)
                          </small>
                        </label>{" "}
                        <br />
                        <div className="campos50">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AC"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AC");
                              }}
                              id={"AC"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AC"}
                            >
                              Acre
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AL"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AL");
                              }}
                              id={"AL"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AL"}
                            >
                              Alagoas
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AP"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AP");
                              }}
                              id={"AP"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AP"}
                            >
                              Amapá
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "AM"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("AM");
                              }}
                              id={"AM"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"AM"}
                            >
                              Amazonas
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "BA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("BA");
                              }}
                              id={"BA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"BA"}
                            >
                              Bahia
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "CE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("CE");
                              }}
                              id={"CE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"CE"}
                            >
                              Ceará
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "DF"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("DF");
                              }}
                              id={"DF"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"DF"}
                            >
                              Distrito Federal
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "ES"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("ES");
                              }}
                              id={"ES"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"ES"}
                            >
                              Espírito Santo
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "GO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("GO");
                              }}
                              id={"GO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"GO"}
                            >
                              Goiás
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MA");
                              }}
                              id={"MA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MA"}
                            >
                              Maranhão
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MT"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MT");
                              }}
                              id={"MT"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MT"}
                            >
                              Mato Grosso
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MS"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MS");
                              }}
                              id={"MS"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MS"}
                            >
                              Mato Grosso do Sul
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "MG"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("MG");
                              }}
                              id={"MG"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"MG"}
                            >
                              Minas Gerais
                            </label>
                          </div>
                        </div>
                        <div className="campos50">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PA"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PA");
                              }}
                              id={"PA"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PA"}
                            >
                              Pará
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PB"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PB");
                              }}
                              id={"PB"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PB"}
                            >
                              Paraíba
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PR"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PR");
                              }}
                              id={"PR"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PR"}
                            >
                              Paraná
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PE");
                              }}
                              id={"PE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PE"}
                            >
                              Pernambuco
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "PI"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("PI");
                              }}
                              id={"PI"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"PI"}
                            >
                              Piauí
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RJ"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RJ");
                              }}
                              id={"RJ"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RJ"}
                            >
                              Rio de Janeiro
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RN"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RN");
                              }}
                              id={"RN"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RN"}
                            >
                              Rio Grande do Norte
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RO");
                              }}
                              id={"RO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RO"}
                            >
                              Rondônia
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "RR"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("RR");
                              }}
                              id={"RR"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"RR"}
                            >
                              Roraima
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SC"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SC");
                              }}
                              id={"SC"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SC"}
                            >
                              Santa Catarina
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SP"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SP");
                              }}
                              id={"SP"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SP"}
                            >
                              São Paulo
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "SE"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("SE");
                              }}
                              id={"SE"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"SE"}
                            >
                              Sergipe
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={this.state.disabled}
                              className="custom-control-input"
                              checked={
                                this.state.estadosId.find(
                                  (item) => item === "TO"
                                )
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                this.ListaUf("TO");
                              }}
                              id={"TO"}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"TO"}
                            >
                              Tocantins
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Profissão */}
                      <div className="campos100">
                        <label>
                          Escolha a Profissão{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            as profissões){" "}
                          </small>
                        </label>
                        {this.state.Profissao.map((tipo, i) => {
                          return (
                            <div className="linha" key={i}>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  disabled={this.state.disabled}
                                  className="custom-control-input"
                                  value={tipo.cad_cod}
                                  checked={this.state.profissoesId.includes(
                                    tipo.cad_cod
                                  )}
                                  onChange={(e) => {
                                    this.ListaProfissao(e.target);
                                    this.setState({
                                      Update: !this.state.Update,
                                    });
                                  }}
                                  id={tipo.cad_cod}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={tipo.cad_cod}
                                >
                                  {tipo.cad_descricao}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {/* Clusters */}
                      <div className="campos100">
                        <label>
                          Escolha os Clusters{" "}
                          <small>
                            (Caso nenhum esteja selecionado, consideramos todos
                            os clusters){" "}
                          </small>
                        </label>
                        {this.state.Cluster.map((clus, i) => {
                          return (
                            <div className="linha" key={i}>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  disabled={this.state.disabled}
                                  className="custom-control-input"
                                  value={clus.id}
                                  checked={this.state.clustersId.includes(
                                    clus.id
                                  )}
                                  onChange={(e) => {
                                    this.ListaCluster(e.target);
                                    this.setState({
                                      UpdateCluster: !this.state.UpdateCluster,
                                    });
                                  }}
                                  id={clus.id}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={clus.id}
                                >
                                  {clus.descricao}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => this.AlteraStatus(this.state.ativo)}
              >
                Alterar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* ARQUIVO */}
          <MDBModal
            isOpen={this.state.modal5}
            toggle={() => this.toggle(5)}
            size="md"
          >
            <MDBModalHeader toggle={() => this.toggle(5)}>
              Cadastro de Visão para Cupom
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol md="12">
                  <a
                    href="http://www.plataformaomnion.com.br/ExcelPromoCode/cupom.xlsx"
                    target="_blank"
                    className="exe"
                  >
                    Baixar modelo de arquivo
                  </a>
                </MDBCol>

                <MDBCol md="12">
                  <label>Enviar com:</label>
                  <select
                    name="tipo"
                    id="tipo"
                    className="browser-default custom-select"
                    onChange={(e) => {
                      this.setState({ tipo: e.target.value });
                    }}
                  >
                    <option value=""> Escolher </option>
                    <option
                      value={1}
                      selected={this.state.tipo === 1 ? "selected" : ""}
                    >
                      {" "}
                      CPF{" "}
                    </option>
                    <option
                      value={2}
                      selected={this.state.tipo === 2 ? "selected" : ""}
                    >
                      {" "}
                      CNPJ{" "}
                    </option>
                  </select>
                </MDBCol>

                <MDBCol md="12">
                  <form>
                    <label>Upload do arquivo</label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          id="inputGroupFileAddon01"
                        >
                          Upload
                        </span>
                      </div>

                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="XLSFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="xlsx/*"
                          onChange={(e) => this.LeArquivo(e)}
                        />
                        <label className="custom-file-label" htmlFor="XLSFile">
                          {this.state.nomearquivo}
                        </label>
                      </div>
                    </div>
                    <small>Extensão .xlsx</small>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="md"
                onClick={() => this.CadastrarArquivo()}
              >
                Cadastrar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        </HomeFornada>
      </Container>
    );
  }
}

export default withRouter(Home);
